import * as React from 'react';
import { gql, useQuery } from '@apollo/client';
import Seo from "./Seo";

const GET_SEO = gql`
  query($url: String) {
        getSeo(url: $url) {
            title
            metaDescription
            metaKeywords
            ogTitle
            ogDescription
            ogImage
            twTitle
            twDescription
            twImage
            canonical
            eParams
        }
  }
`;

export default function(props) {

    const {loading, error, data, refetch} = useQuery(GET_SEO, {variables: {url: props.url}});

    if (data && props.onData) {
        props.onData(data.getSeo);
    }

    if (data && props.onEParams) {
        props.onEParams(JSON.parse(data.getSeo.eParams));
    }

    return data ? <Seo seo={data.getSeo}/> : null;
}